// extracted by mini-css-extract-plugin
module.exports = {"facePile":"face-pile_facePile_MwJ","isRightAligned":"face-pile_isRightAligned_Nzl"};